import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3388d1d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bind-mobile-model"
}
const _hoisted_2 = { class: "pickerfooter" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "body" }
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "请输入手机号", -1))
const _hoisted_12 = { class: "form-item-input" }
const _hoisted_13 = { class: "g-input g-input__placeholder flex-form-input no-padding" }
const _hoisted_14 = { class: "form-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "验证码", -1))
const _hoisted_16 = { class: "form-item-input" }
const _hoisted_17 = { class: "flex-form-input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-tips" }, "未注册用户登录默认注册格布小包账户", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Picker = _resolveComponent("Picker")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.isShowModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Picker, {
          "is-hide-header": true,
          options: _ctx.pickerOptions,
          "is-show-picker": _ctx.isShowPicker,
          modelValue: _ctx.selectCountryId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectCountryId) = $event)),
          onCancel: _ctx.onClosePicker
        }, {
          footer: _withCtx(({ option }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "g-button g-button-primary cancel",
                onClick: option.cancel
              }, " 取消 ", 8, _hoisted_3),
              _createElementVNode("div", {
                class: "g-button g-button-primary confirm",
                onClick: option.confirm
              }, " 确认 ", 8, _hoisted_4)
            ])
          ]),
          _: 1
        }, 8, ["options", "is-show-picker", "modelValue", "onCancel"]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" 手机号登录 "),
              _createVNode(_component_Icon, {
                class: "icon bind-mobile-model-close",
                onClick: _ctx.closeModal,
                icon: "btn_cancel"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "prefix",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPicker && _ctx.showPicker(...args)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.smsTypeText) + " ", 1),
                      _createVNode(_component_Icon, {
                        class: "icon",
                        icon: "btn_arrow_down"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "填写手机号码",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phoneNumber) = $event)),
                      class: "main"
                    }, null, 512), [
                      [_vModelText, _ctx.phoneNumber]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "验证码",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.verifyCode) = $event)),
                      class: "g-input g-input__placeholder msg-input"
                    }, null, 512), [
                      [_vModelText, _ctx.verifyCode]
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.senMsgCode && _ctx.senMsgCode(...args))),
                      class: "send-msg-btn"
                    }, _toDisplayString(_ctx.btnText), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
            class: "footer"
          }, "立 即 登 录")
        ])
      ]))
    : _createCommentVNode("", true)
}